import { Component, Vue } from 'vue-facing-decorator';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Shared scroll-reveal behavior.
 * Any element with `data-reveal` inside a component that mixes this in
 * fades up as it enters the viewport. Respects prefers-reduced-motion.
 */
@Component
export class RevealMixin extends Vue {
  mounted(): void {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const targets = gsap.utils.toArray<HTMLElement>(
      this.$el.querySelectorAll('[data-reveal]'),
    );

    targets.forEach((el) => {
      gsap.fromTo(
        el,
        { y: 26, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        },
      );
    });
  }
}